import { IOption, Option } from '@/interfaces/field';

export const YES_NO_OPTION = [
    new Option(true, 'Sim'),
    new Option(false, 'Não')
] as IOption[];